import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-add.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const AddIcon = createSvgIcon(<Icon />, 'AddIcon');
